import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=25bff196"
import script from "./PurchaseModal.vue?vue&type=script&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=25bff196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports